import React from "react";

import { AttributeContextProvider } from "../../../../Components/GMS/Attribute/AttributeContext";
import AttributeManage from "../../../../Components/GMS/Attribute/Manage";

function Attribute(props) {
  return (
    <AttributeContextProvider>
      <AttributeManage props={props} />
    </AttributeContextProvider>
  );
}

export default Attribute;
